// E-Ticaret › Yasal Sözleşmeler sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'ecommerce.legalDocuments';

export const ecommerceLegalDocumentsGuide = (t: TFunction): GuideContent => ({
  layout: 'stacked',
  title: t(`${G}.title`, 'Yasal Sözleşmeler nasıl hazırlanır?'),
  intro: t(`${G}.intro`, 'Sitenizde yayınlanması gereken Çerez Politikası, KVKK Aydınlatma Metni, Gizlilik Sözleşmesi, Mesafeli Satış Sözleşmesi, İptal ve İade Politikası ve Kullanım Koşulları gibi belgeleri burada oluşturur, düzenler ve yayına alırsınız. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Yasal Sözleşmeler'),
    form: t(`${G}.regions.form`, 'Şirket adı ve belge ekleme'),
    list: t(`${G}.regions.list`, 'Belgeler'),
    footer: t(`${G}.regions.footer`, 'Sil / Kaydet'),
  },
  steps: [
    {
      region: 'form',
      title: t(`${G}.s1.title`, '1. Belgeleri ekleyin'),
      text: t(`${G}.s1.text`, '"Zorunlu belgeleri taslak olarak oluştur" düğmesi, eksik olan zorunlu belge tiplerini hazır Türkçe taslaklarla ekler; var olan belgelere dokunmaz. Listede olmayan başka bir metin için "Yeni belge ekle" ile boş bir "Özel Belge" açın.'),
      tips: [
        t(`${G}.s1.tip1`, 'Taslaklar Pasif başlar; içeriği gözden geçirip aktifleştirmeden sitede görünmez.'),
        t(`${G}.s1.tip2`, 'Yeni eklenen belge de Pasif başlar ve "Kaydet"e basılana kadar kaydedilmez ("Kaydedilmedi" etiketi görünür).'),
      ],
    },
    {
      region: 'form',
      title: t(`${G}.s2.title`, '2. Şirket adını (ünvanı) yerleştirin'),
      text: t(`${G}.s2.text`, '"Şirket Adı / Yasal Ünvan" kutusuna şirketinizin resmi ünvanını yazıp "Tüm belgelere uygula"ya basın. Belge metinlerindeki şirket adı yer tutucularının yerine bu isim yazılır ve tüm belgeler hemen kaydedilir.'),
      tips: [
        t(`${G}.s2.tip1`, 'Bir belgenin içine ünvanın geleceği yeri eklemek için "Şirket adı yer tutucusu ekle" düğmesini kullanın; yer tutucu metnin sonuna eklenir.'),
        t(`${G}.s2.tip2`, 'Uygulama sonrası yer tutucu metinden kalkar. Ünvan değişirse ilgili yerleri belge içinde elle düzeltin.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s3.title`, '3. Başlık, adres ve içerik'),
      text: t(`${G}.s3.text`, 'Belgenin satırına tıklayıp açın. "Başlık" zorunludur. "Slug (opsiyonel)" belgenin sitedeki adresidir: belge /legal/slug adresinde yayınlanır; boş bırakılırsa başlıktan üretilir. "İçerik" alanındaki araç çubuğuyla metni biçimlendirin.'),
      tips: [
        t(`${G}.s3.tip1`, 'Aynı slug iki belgede kullanılamaz; kaydederken "slug zaten başka bir belgede kullanılıyor" uyarısı çıkarsa farklı bir slug yazın.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s4.title`, '4. Yayın, footer ve geçiş ayarları'),
      text: t(`${G}.s4.text`, '"Aktif (yayında)" anahtarı belgeyi sitede yayına alır; kayıtlı bir belgede anahtarı değiştirdiğiniz anda kaydedilir. "Footer\'da göster" açık olan aktif belgeler sitenin alt bilgisinde "Yasal" başlığı altında listelenir.'),
      tips: [
        t(`${G}.s4.tip1`, '"Sözleşmeler arası geçişte göster" açık belgeler sitede birbirine geçiş yapılabilecek şekilde birlikte listelenir. "Geçiş grubu" aynı olan belgeler birlikte görünür; boş bırakılırsa varsayılan gruptadır.'),
        t(`${G}.s4.tip2`, '"Vitrin önizlemesi" bu belgenin grubundaki sözleşmeleri gösterir; geçişin görünmesi için aynı grupta en az iki belge olmalıdır.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s5.title`, '5. Sırayı belirleyin'),
      text: t(`${G}.s5.text`, 'Satırın solundaki yukarı / aşağı oklarla belgelerin sırasını değiştirin. Yeni sıra hemen kaydedilir.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s6.title`, '6. Kaydedin veya silin'),
      text: t(`${G}.s6.text`, 'Başlık, slug, footer, geçiş ve içerik değişiklikleri belgenin altındaki "Kaydet" ile kaydedilir; kaydedilmemiş belgelerde "Kaydedilmedi" etiketi görünür. "Sil" belgeyi kalıcı olarak siler, bu işlem geri alınamaz.'),
      tips: [
        t(`${G}.s6.tip1`, 'Başlıktaki (i) düğmesi bu rehberi her zaman yeniden açar.'),
      ],
    },
  ],
});
